/**
 * Is this bill discount a redeemed-loyalty-points discount? Pure: the revamped code's home of the
 * test (2026-10-06), so v2's write path can ask it without importing a v1 helper (rule 14). v1's
 * own copy, `helpers/loyaltyHelper/shared.ts` › `isLoyaltyPointDiscountType`, stays until its
 * cutover (no v1 change without the user's approval); the two must stay identical.
 *
 * Identified structurally (`loyaltyPoints` + `dclass === "Discount"`) because these entries carry
 * neither `discountId` nor `mid` — which is exactly why `shouldRetainBillDiscount` has to ask.
 *
 * 🔴 Never re-derive this test inline; import it (here for revamped code, v1's helper for v1) —
 * `docs/flows/LOYALTY_REFUND.md` explains what that cost in production.
 */
export const isLoyaltyPointDiscountType = (discount: any): boolean => {
  return discount?.loyaltyPoints && discount?.dclass === "Discount";
};
